<template>
  <div class="py-3 px-4 text-start style-list-header scss-title">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "SubHeader",
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.style-list-header {
  color: $text-blue;
  font-size: 18px;
}
</style>
